import React from "react";
import cardItemImg1 from "assets/landing/block-services-1.webp";
import cardItemImg2 from "assets/landing/block-services-2.webp";
import cardItemImg3 from "assets/landing/block-services-3.webp";
import cardItemImg4 from "assets/landing/block-services-4.webp";
import cardItemImg5 from "assets/landing/block-services-5.webp";
import "./style.scss";
import { useTranslation } from "locales";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";

export default function BlockServicesLanding() {
  const { t } = useTranslation();

  const cardItems = [
    {
      title: t("Technical Guidance"),
      description: t("Learn to think the way real firms do and prove it under pressure."),
      img: cardItemImg3,
    },
    {
      title: t("CV & Cover Letter"),
      description: t("Craft a standout story that gets interviews."),
      img: cardItemImg1,
    },
    {
      title: t("Behavioural & Fit"),
      description: t("Speak with confidence, authenticity, and clarity."),
      img: cardItemImg2,
    },
    {
      title: t("Industry Insight"),
      description: t("Connect what you’ve studied to what’s really happening in markets."),
      img: cardItemImg4,
    },
    {
      title: t("Case Interview"),
      description: t("Solve problems with the structure and composure top firms demand."),
      img: cardItemImg5,
    },
  ];

  return (
    <div className="block-services-landing d-flex __align-center __column text-center">
      <h2 className="block-services-landing__title h2 mb-4">
        {t("Five essentials every financial services student must master")}
      </h2>
      <div className="block-services-landing__description subtitle-1 text-neutral-darken-1 mb-10">
        {t(
          "Secure The Offer's insider coaching provides the key skills tested by top firms, with tailored sessions from elite alumni to convert interviews into offers."
        )}
      </div>
      <div className="block-services-landing__cards mb-10">
        {cardItems.map((i, index) => (
          <div key={index} className="block-services-landing__card">
            <div className="block-services-landing__card-inner">
              <div className="block-services-landing__card-front" style={{ backgroundImage: `url(${i.img})` }}>
                <div className="block-services-landing__card-text-wrapper d-flex __column px-4 pb-3">
                  <div className="block-services-landing__card-text caption-1 fw-bold">{i.title}</div>
                </div>
              </div>
              <div className="block-services-landing__card-back pa-4 d-center gap-1">
                <div className="block-services-landing__card-text caption-1 fw-bold">{i.title}</div>
                <div className="fw-semibold">{i.description}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <BaseButton className="block-services-landing__btn body-1 fw-bold pl-4 pr-3" to={"/coaches"} large gradient>
        {t("Find a Coach")}
        <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
      </BaseButton>
    </div>
  );
}
